import update from 'immutability-helper'
import {
  CLEAR_TRANSACTION_DETAILS,
  CREDIT_TRANSACTION_SUCCESS,
  GET_CART_SUMMARY_FAILED,
  GET_CART_SUMMARY_SUCCESS,
  GET_TRANSACTION_DETAILS,
  RESET_TRANSACTIONS,
  SET_CURRENT_TRANSACTION_ID,
  SET_TERMINAL_TRANSACTION,
  TRANSACTION_DEBIT_LOADING,
  TRANSACTION_DETAILS_ACTION_ACTIVE,
  TRANSACTION_DETAILS_ACTION_FAILED,
  TRANSACTION_DETAILS_ACTION_SUCCESS,
  TRANSACTION_HAS_INVOICE_REF_ACTIVE,
  TRANSACTION_HAS_INVOICE_REF_CANCEL,
  TRANSACTION_HAS_INVOICE_REF_FAILED,
  TRANSACTION_HAS_INVOICE_REF_SUCCESS,
} from '../actions/action-types'

const initialState = {
  currentTransactionId: null,
  currentTransactionDetails: null,
  currentTransactionCart: {
    cart: {},
    cartStatus: {},
    getCartState: {
      loading: false,
    },
  },
  terminalTransactions: {
    current: null,
    latestCredit: null,
  },
  action: {
    loading: false,
    active: false,
  },
  invoiceRef: {
    required: null,
  },
  debitLoading: false,
}

// eslint-disable-next-line default-param-last
const transactions = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TRANSACTIONS:
      return initialState
    case GET_CART_SUMMARY_SUCCESS: {
      return update(state, {
        currentTransactionCart: {
          cart: {
            $set: action.response.cart,
          },
          cartStatus: {
            $set: action.response.status,
          },
          getCartState: {
            failed: {
              $set: false,
            },
          },
        },
      })
    }
    case GET_CART_SUMMARY_FAILED: {
      return update(state, {
        currentTransactionCart: {
          getCartState: {
            failed: {
              $set: true,
            },
          },
        },
      })
    }

    case GET_TRANSACTION_DETAILS: {
      return update(state, {
        currentTransactionDetails: {
          $set: action.response,
        },
      })
    }
    case CLEAR_TRANSACTION_DETAILS: {
      return update(state, {
        currentTransactionDetails: {
          $set: null,
        },
        currentTransactionCart: {
          cart: {
            $set: null,
          },
          cartStatus: {
            $set: null,
          },
        },
        terminalTransactions: {
          current: { $set: null },
        },
        currentTransactionId: { $set: null },
      })
    }
    case SET_CURRENT_TRANSACTION_ID: {
      return update(state, {
        currentTransactionId: {
          $set: action.id,
        },
      })
    }

    case SET_TERMINAL_TRANSACTION:
      return update(state, {
        terminalTransactions: {
          current: { $set: action.transaction },
        },
      })
    case TRANSACTION_DETAILS_ACTION_ACTIVE: {
      return update(state, {
        action: {
          loading: {
            $set: true,
          },
          active: {
            $set: true,
          },
        },
      })
    }
    case TRANSACTION_DETAILS_ACTION_SUCCESS: {
      return update(state, {
        action: {
          loading: {
            $set: false,
          },
        },
        active: {
          $set: false,
        },
        invoiceRef: {
          required: {
            $set: null,
          },
        },
      })
    }
    case TRANSACTION_DETAILS_ACTION_FAILED: {
      return update(state, {
        action: {
          loading: {
            $set: false,
          },
          active: {
            $set: false,
          },
        },
        invoiceRef: {
          required: {
            $set: null,
          },
        },
      })
    }
    case TRANSACTION_HAS_INVOICE_REF_ACTIVE: {
      return update(state, {
        action: {
          loading: {
            $set: true,
          },
          active: {
            $set: false,
          },
        },
      })
    }
    case TRANSACTION_HAS_INVOICE_REF_SUCCESS: {
      return update(state, {
        invoiceRef: {
          required: {
            $set: action.response,
          },
        },
        action: {
          loading: {
            $set: true,
          },
          active: {
            $set: false,
          },
        },
      })
    }
    case TRANSACTION_HAS_INVOICE_REF_FAILED: {
      return update(state, {
        action: {
          loading: {
            $set: false,
          },
          active: {
            $set: false,
          },
        },
        invoiceRef: {
          required: {
            $set: null,
          },
        },
      })
    }
    case TRANSACTION_HAS_INVOICE_REF_CANCEL: {
      return update(state, {
        action: {
          loading: {
            $set: false,
          },
          active: {
            $set: false,
          },
        },
        invoiceRef: {
          required: {
            $set: null,
          },
        },
      })
    }
    case TRANSACTION_DEBIT_LOADING: {
      return update(state, {
        debitLoading: {
          $set: action.status,
        },
      })
    }
    case CREDIT_TRANSACTION_SUCCESS: {
      return update(state, {
        terminalTransactions: {
          latestCredit: {
            $set: action.response,
          },
        },
      })
    }
    default:
      return state
  }
}

export default transactions
